module.exports = __webpack_public_path__ + "img/pipe-3.5efca926.png";